import { Chip, Stack } from "@mui/material";

type GridCellChipsContentProps = {
    keyField: string,
    displayTextFiled: string,
    cellData: any[],
    onClose?: (value: any) => void,
    classNames?: string,
    showViewMore?: boolean,
    viewMoreHandle?: (gridParams) => void,
    viewMoreText?: string,
}

export default function GridCellChipsContent(props: GridCellChipsContentProps) {
    return (
        <div className={`cell-chips ${props?.classNames}`}>
          {props.cellData.map((item: any) => (                
            <Stack direction="row" key={item[props.keyField]} spacing={1} 
              component="span" 
              sx={{ margin:"3px", display:"inline-block" }}>
                <Chip label={ item[props.displayTextFiled]} component="span" onDelete={props.onClose && (() => props.onClose(item))} />
            </Stack>
          ))}
          {props.showViewMore && <span className="view-more" onClick={props.viewMoreHandle}>{props?.viewMoreText || "Show All"}</span>}
        </div>
      ); 
}